/*
  This component renders a ListWithDividers, with SeriesBook items
  and series position headers.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import ListWithDividers from "../list_with_dividers";
import SeriesBook from "./series_book";

const SeriesList = ({ series, seriesHeaders }) => (
  <ListWithDividers ItemComponentType={SeriesBook}
                    items={series}
                    itemHeaders={seriesHeaders} />
);

SeriesList.propTypes = {
  series: PropTypes.array.isRequired,
  seriesHeaders: PropTypes.array,
};

export default SeriesList;
